import { FC } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import App from "../app/App";
import PublicLayout from "./PublicLayout";

/**
 * Renders DashboardLayout (sidebar + full top bar) for authenticated users,
 * PublicLayout (minimal top bar) for anonymous users.
 */
const AdaptiveLayout: FC = () => {
  const isAuthenticated = useSelector((s: RootState) => s.session.isAuthenticated);

  if (isAuthenticated) {
    return <App />;
  }

  return <PublicLayout />;
};

export default AdaptiveLayout;
